<!-- Header -->
<div class="ticket-card d-flex flex-column flex-lg-row align-items-lg-center justify-content-between p-3 p-md-4 mb-3">
  <div>
    <p class="fs-xsmall fw-800 color-brand-primary-700 mb-1">{{'tickets.line_label'|translate|uppercase}}</p>
    <p class="fs-20 fw-800 color-gray-950 mb-0">{{'menu.tickets'|translate}}</p>
    <p class="fs-small fw-400 color-gray-400 mb-0">
      {{'tickets.header_desc'|translate}}
      <span *ngIf="waitingReplyCount"> — {{'tickets.waiting_count'|translate: {count: waitingReplyCount} }}</span>
    </p>
  </div>

  <div class="mt-3 mt-lg-0">
    <app-gray-button
      [color]="formIsOpen ? 'stroke' : 'primary'" [fullWidth]="false" padding="p-0" [weight]="800"
      customClass="header-btn fs-small"
      [text]="(formIsOpen ? 'buttons.give_up' : 'tickets.new_question')|translate"
      (click)="toggleForm()"></app-gray-button>
  </div>
</div>

<!-- New question -->
<div class="ticket-card p-3 p-md-4 mb-3" *ngIf="formIsOpen">
  <form [formGroup]="fg" (ngSubmit)="createTicket()">

    <div class="row">
      <div class="col-12 col-lg-8">
        <label class="color-gray-500 fw-500 fs-normal">{{'tickets.subject'|translate}}</label>
        <app-gray-text-input
          [hasErr]="isSubmitted && fg.get('title')?.invalid"
          [placeholder]="'tickets.subject_placeholder'|translate"
          formControlName="title"></app-gray-text-input>
        <div class="form-errors mt-1" *ngIf="isSubmitted && fg.get('title')?.errors">
          <p>{{'errors.required'|translate}}</p>
        </div>
      </div>

      <div class="col-12 col-lg-4 mt-3 mt-lg-0">
        <label class="color-gray-500 fw-500 fs-normal d-block mb-2">{{'tickets.urgency'|translate}}</label>
        <app-gray-pill-select-input
          [items]="urgencyOptions" bindValue="id" bindLabel="name"
          formControlName="urgency"></app-gray-pill-select-input>
        <p class="fs-small fw-400 color-gray-400 mt-2 mb-0"
           *ngIf="fg.get('urgency')?.value === ticketUrgency.High">
          {{'tickets.urgency_high_note'|translate}}
        </p>
      </div>
    </div>

    <div class="mt-3">
      <label class="color-gray-500 fw-500 fs-normal d-block mb-2">{{'tickets.tags'|translate}}</label>
      <div class="d-flex flex-wrap gap-2">
        <a class="tag-chip fs-small fw-800 clickable px-3 py-1" *ngFor="let tag of tags"
           [class.selected]="isTagSelected(tag.id)" (click)="toggleTag(tag.id)">
          {{tag.name}}
        </a>
        <p class="fs-small fw-400 color-gray-400 mb-0" *ngIf="!tags.length">{{'tickets.no_tag_defined'|translate}}</p>
      </div>
      <div class="form-errors mt-1" *ngIf="isSubmitted && fg.get('tagIds')?.errors">
        <p>{{'tickets.tags_required'|translate}}</p>
      </div>
    </div>

    <div class="mt-3">
      <label class="color-gray-500 fw-500 fs-normal">{{'tickets.detail'|translate}}</label>
      <textarea
        class="ticket-textarea w-100" formControlName="message"
        [placeholder]="'tickets.detail_placeholder'|translate"></textarea>
      <div class="form-errors mt-1" *ngIf="isSubmitted && fg.get('message')?.errors">
        <p>{{'errors.required'|translate}}</p>
      </div>
    </div>

    <div class="d-flex justify-content-end mt-3">
      <app-gray-button
        type="submit" color="primary" [fullWidth]="false" padding="px-4 py-2" [weight]="800"
        customClass="fs-small" [isLoading]="createIsLoading" [disabled]="createIsLoading"
        [text]="'tickets.send'|translate"></app-gray-button>
    </div>
  </form>
</div>

<!-- Filters -->
<div class="d-flex flex-column flex-lg-row align-items-lg-center justify-content-between mb-3">
  <div class="tab-switch d-inline-flex p-1">
    <a
      class="tab-item fs-small fw-800 clickable" *ngFor="let tab of statusTabs"
      [class.active]="statusFilter === tab.value" (click)="setStatusFilter(tab.value)">
      {{tab.labelKey|translate}}
    </a>
  </div>

  <div class="d-flex align-items-center mt-3 mt-lg-0">
    <div class="urgency-filter me-2">
      <app-gray-select-input
        [items]="urgencyOptions" bindLabel="name" bindValue="id"
        [placeholder]="'tickets.urgency'|translate"
        (changed)="setUrgencyFilter($event)"></app-gray-select-input>
    </div>

    <div class="search-input">
      <app-gray-text-input
        icon="search" [placeholder]="'tickets.search'|translate"
        [(ngModel)]="searchText" [ngModelOptions]="{standalone: true}"
        (keyup.enter)="applyFilters()"></app-gray-text-input>
    </div>
  </div>
</div>

<!-- Tag filter -->
<div class="d-flex flex-wrap align-items-center gap-2 mb-3" *ngIf="tags.length">
  <span class="fs-xsmall fw-800 color-gray-500 me-1">{{'tickets.filter_tags'|translate|uppercase}}</span>

  <a class="tag-chip fs-small fw-800 clickable px-3 py-1" *ngFor="let tag of tags"
     [class.selected]="isTagFiltered(tag.id)" (click)="toggleTagFilter(tag.id)">
    {{tag.name}}
  </a>

  <a class="fs-small fw-800 color-gray-400 clickable ms-1" *ngIf="tagFilterIds.length"
     (click)="clearTagFilter()">{{'tickets.clear_tag_filter'|translate}}</a>
</div>

<!-- List -->
<div class="ticket-card p-5 text-center" *ngIf="!tickets.length && !isLoading">
  <p class="fs-normal fw-800 color-gray-950 mb-1">{{'tickets.empty_title'|translate}}</p>
  <p class="fs-small fw-400 color-gray-400 mb-0">{{'tickets.empty_desc'|translate}}</p>
</div>

<div class="ticket-card mb-2" *ngFor="let ticket of tickets">

  <a class="ticket-head d-flex align-items-center justify-content-between p-3 clickable"
     (click)="toggleTicket(ticket)">
    <div class="d-flex align-items-center overflow-hidden">
      <span class="status-icon me-3"
            [class.waiting]="ticket.status === ticketStatus.WaitingReply"
            [class.answered]="ticket.status === ticketStatus.Answered"
            [class.closed]="ticket.status === ticketStatus.Closed">
        <i class="bi" [class.bi-clock]="ticket.status === ticketStatus.WaitingReply"
           [class.bi-check-circle]="ticket.status === ticketStatus.Answered"
           [class.bi-slash-circle]="ticket.status === ticketStatus.Closed"></i>
      </span>

      <div class="overflow-hidden">
        <p class="fs-normal fw-800 color-gray-950 mb-0 text-truncate">{{ticket.title}}</p>
        <p class="fs-small fw-400 color-gray-400 mb-0">
          {{ticket.lastMessageAt|date:'d MMMM yyyy'}} ·
          <span [class.color-gray-600]="ticket.status !== ticketStatus.WaitingReply">
            {{('tickets.status_' + (ticket.status === ticketStatus.WaitingReply ? 'waiting' :
               ticket.status === ticketStatus.Answered ? 'answered' : 'closed'))|translate}}
          </span>
        </p>

        <div class="d-flex flex-wrap gap-1 mt-1" *ngIf="ticketTags(ticket).length">
          <span class="tag-badge fs-xsmall fw-800" *ngFor="let tag of ticketTags(ticket)">{{tag.name}}</span>
        </div>
      </div>
    </div>

    <div class="d-flex align-items-center">
      <span class="urgency-badge fs-xsmall fw-800 me-2"
            [class.high]="ticket.urgency === ticketUrgency.High"
            [class.medium]="ticket.urgency === ticketUrgency.Medium"
            [class.low]="ticket.urgency === ticketUrgency.Low">
        {{('tickets.urgency_' + (ticket.urgency === ticketUrgency.High ? 'high' :
           ticket.urgency === ticketUrgency.Medium ? 'medium' : 'low'))|translate|uppercase}}
      </span>
      <i class="bi color-gray-400" [class.bi-chevron-down]="openTicketId !== ticket.id"
         [class.bi-chevron-up]="openTicketId === ticket.id"></i>
    </div>
  </a>

  <!-- Thread -->
  <div class="ticket-body px-3 pb-3" *ngIf="openTicketId === ticket.id">
    <p class="fs-small fw-400 color-gray-400" *ngIf="detailIsLoading">{{'labels.loading'|translate}}</p>

    <ng-container *ngIf="openTicket">
      <div class="d-flex mb-2" *ngFor="let message of openTicket.messages"
           [class.admin]="message.senderType === senderType.Admin">
        <div class="message-bubble p-3 w-100"
             [class.from-admin]="message.senderType === senderType.Admin">
          <p class="fs-small fw-800 mb-1" *ngIf="message.senderType === senderType.Admin">
            <span class="color-brand-primary-700">{{'app.name'|translate}}</span>
            <span class="fs-xsmall fw-400 color-gray-400 ms-2">{{message.createdAt|date:'d MMMM yyyy'}}</span>
          </p>
          <p class="fs-xsmall fw-400 color-gray-400 mb-1" *ngIf="message.senderType === senderType.Coach">
            {{message.createdAt|date:'d MMMM yyyy, HH:mm'}}
          </p>
          <p class="fs-small fw-400 color-gray-950 mb-0">{{message.body}}</p>
        </div>
      </div>

      <!-- Reply -->
      <div class="mt-3" *ngIf="openTicket.status !== ticketStatus.Closed">
        <form [formGroup]="fgReply" (ngSubmit)="sendReply()">
          <textarea
            class="ticket-textarea w-100" formControlName="body"
            [placeholder]="'tickets.reply_placeholder'|translate"></textarea>
          <div class="form-errors mt-1" *ngIf="replyIsSubmitted && fgReply.get('body')?.errors">
            <p>{{'errors.required'|translate}}</p>
          </div>

          <div class="d-flex justify-content-between align-items-center mt-2">
            <a class="fs-small fw-800 color-gray-400 clickable" (confirm)="closeTicket(openTicket)" [swal]="{
                 text: ('tickets.close_confirm'|translate),
                 showDenyButton: false,
                 showCancelButton: true,
                 cancelButtonText: 'buttons.cancel_l'|translate,
                 confirmButtonText: 'buttons.yes'|translate,
                 heightAuto: false
               }">
              {{'tickets.close'|translate}}
            </a>

            <app-gray-button
              type="submit" color="primary" [fullWidth]="false" padding="px-4 py-2" [weight]="800"
              customClass="fs-small" [isLoading]="replyIsLoading" [disabled]="replyIsLoading"
              [text]="'tickets.reply'|translate"></app-gray-button>
          </div>
        </form>
      </div>

      <p class="closed-note fs-small fw-500 color-gray-400 mt-3 mb-0"
         *ngIf="openTicket.status === ticketStatus.Closed">
        {{'tickets.closed_note'|translate}}
      </p>
    </ng-container>
  </div>

</div>

<div class="text-center mt-3" *ngIf="hasMore">
  <app-gray-button
    color="stroke" [fullWidth]="false" padding="px-4 py-2" [weight]="500"
    customClass="fs-small" [isLoading]="isLoading" [disabled]="isLoading"
    [text]="'tickets.load_more'|translate" (click)="loadMore()"></app-gray-button>
</div>
